export const faq_CreateContent = [
	{
		icon: '💬',
		title: 'faqData.title1',
		subtitle: 'faqData.subtitle1',
	},
	{
		icon: '💬',
		title: 'faqData.title2',
		subtitle: 'faqData.subtitle2',
	},
	{
		icon: '💬',
		title: 'faqData.title3',
		subtitle: 'faqData.subtitle3',
	},
];
